import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {ShippingProviderConfiguration} from '../models/shipping/shippingProviderConfiguration.model';
import {ShippingOrder} from '../models/shipping/shippingOrder.model';

@Injectable({
  providedIn: 'root'
})
export class ShippingService {

  private SHIPPING_URL: string = environment.BASE_URL + 'shipping';

  constructor(private http: HttpClient) {
  }

  public getProviders(): Observable<Array<ShippingProviderConfiguration>> {
    return this.http.get<Array<ShippingProviderConfiguration>>(`${this.SHIPPING_URL}/provider`);
  }

  public getProvider(id: string): Observable<ShippingProviderConfiguration> {
    return this.http.get<ShippingProviderConfiguration>(`${this.SHIPPING_URL}/provider/${id}`);
  }

  public createProvider(provider: ShippingProviderConfiguration): Observable<ShippingProviderConfiguration> {
    return this.http.post<ShippingProviderConfiguration>(`${this.SHIPPING_URL}/provider`, provider);
  }

  public updateProvider(provider: ShippingProviderConfiguration): Observable<ShippingProviderConfiguration> {
    return this.http.patch<ShippingProviderConfiguration>(`${this.SHIPPING_URL}/provider/${provider.id}`, provider);
  }

  public deleteProvider(provider: ShippingProviderConfiguration): Observable<ShippingProviderConfiguration> {
    return this.http.delete<ShippingProviderConfiguration>(`${this.SHIPPING_URL}/provider/${provider.id}`);
  }

  public getShippingProviders(): Observable<string[]> {
    return this.http.get<string[]>(`${this.SHIPPING_URL}/providers`);
  }

  public getShippingOrder(id: string): Observable<ShippingOrder> {
    return this.http.get<ShippingOrder>(`${this.SHIPPING_URL}/orders/${id}`);
  }

  public getShippingOrders(): Observable<Array<ShippingOrder>> {
    return this.http.get<Array<ShippingOrder>>(`${this.SHIPPING_URL}/orders`);
  }

  public requestShippingOrder(id: string): Observable<ShippingOrder> {
    return this.http.post<ShippingOrder>(`${this.SHIPPING_URL}/orders/${id}`, {});
  }

  public updateShippingOrder(id: string, shippingOrder: ShippingOrder): Observable<ShippingOrder> {
    return this.http.patch<ShippingOrder>(`${this.SHIPPING_URL}/orders/${id}`, {
      status: shippingOrder.status
    });
  }
}
